import { createFileRoute } from "@tanstack/react-router";
import { pageHead, contactPageJsonLdScript } from "@/lib/seo";

const TITLE = "Contact — Plan je gratis demo | IT Solutions";
const DESC =
  "Stuur je URL of brief en ontvang binnen 24 uur een evaluatierapport plus een live demo op je eigen subdomein. hello@itsolutions.be.";

import { ContactPage } from "@/pages/contact";

export const Route = createFileRoute("/contact")({
  head: () => {
    const head = pageHead({
      lang: "nl",
      pathWithoutLang: "/contact",
      title: TITLE,
      description: DESC,
    });
    return {
      ...head,
      scripts: [contactPageJsonLdScript("nl")],
    };
  },
  component: ContactPage,
});
